import Vue from "vue"
import Vuex from "vuex";
import actions from "./actions";
import mutations from "./mutations";
import moment from "moment";


Vue.use(Vuex);

const backgrounds = [
	"http://getwallpapers.com/wallpaper/full/3/7/b/365642.jpg",
	"http://getwallpapers.com/wallpaper/full/3/9/0/365690.jpg",
	"http://getwallpapers.com/wallpaper/full/1/3/5/365887.jpg",
	"http://getwallpapers.com/wallpaper/full/2/1/0/489789.jpg",
	'http://getwallpapers.com/wallpaper/full/a/5/d/544750.jpg'
]


export default new Vuex.Store({
	state: {
		user: {
			logged_in: false,
			data: null,
			error: false,
		},
		socket: {
			isConnected: false,
			message: '',
			reconnectError: false,
		},
		geography: {
			error: false,
			data: {
				slug: 'vadc',
				type: 'market',
			}
		},
		header: {
			visible: true
		},
		globalAlert: {
			alert: false,
			data: null,
		},
		introStatus: {
			status: false,
		},
		loading: false
	},
	actions: actions,
	mutations: mutations,
	getters: {
		getAlerts: state => {
			return state.globalAlert
		},
		permissions_list: state => {
			return state.user.data.permissions_list;
		}
	}
})

